import { Fragment, memo } from 'react';

import { useWorkflowProgressBarViewModel } from './WorkflowProgressBarViewModel';
import styles from './WorkflowProgressBar.module.scss';

export const WorkflowProgressBar = memo(function WorkflowProgressBar() {
  const vm = useWorkflowProgressBarViewModel();

  return (
    <div className={styles.container}>
      <div className={styles.track} role="group" aria-label="Publication workflow progress">
        {vm.stages.map((stage, i) => (
          <Fragment key={stage.label}>
            {i > 0 && <span className={styles.connector} aria-hidden="true" />}
            <div
              className={`${styles.circle} ${styles[stage.state]}`}
              title={stage.label}
              aria-label={`${stage.label}: ${stage.state === 'in-progress' ? 'in progress' : stage.state}`}
            >
              {stage.state === 'completed' && (
                <svg width="14" height="11" viewBox="0 0 10 8" fill="none" aria-hidden="true">
                  <path
                    d="M1 4L3.5 6.5L9 1"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
          </Fragment>
        ))}
      </div>
      <div className={styles.label}>{vm.stageLabel}</div>
    </div>
  );
});
